<template>
  <v-carousel-item>
    <v-container class="py-8" style="overflow: auto;">
      <div 
        class="headline text-center font-weight-black pa-2 mb-2 question" 
        :style="'background-color: ' + sliderQuestionBG + '; color: ' +  sliderFontQuestion + ';'"
        v-text="question.text"
      >
      </div>
      <v-row class="pt-4">
        <v-col>
          <v-row style="max-height: 310px;">

            <!-- Cell -->
            <div v-for="card in textAndImageArray" @click="clickCard(card.text)" :id="card.text" class="grid-item mx-5 mb-4">


              <!-- Top Cell -->
              <div 
                class="grid-cell--top pa-6" 
                :style="activeCard == card.text ?
                  'background-color: ' + sliderCardTop + 
                  ';' + 'border-left: 2px solid ' + sliderCardBorderSelected + 
                  '; border-top: 2px solid ' + sliderCardBorderSelected + 
                  '; border-right: 2px solid ' + sliderCardBorderSelected + ';' 
                : 
                  'background-color: ' + sliderCardTop + 
                  ';' + 'border-left: 2px solid ' + sliderCardBorderDefault + 
                  '; border-top: 2px solid ' + sliderCardBorderDefault + 
                  '; border-right: 2px solid ' + sliderCardBorderDefault + ';'"
                >

                <v-img class="img" :src="card.img" :contain="true"></v-img>
              </div>

              <!-- Bottom Cell -->
              <div class="grid-cell--bottom pa-5" :style="'background-color: ' + sliderCardBottom">
                <p class="grid-text" :style="'color: ' + sliderFontCards + ';'" v-text="card.text"></p>
              </div>

            </div>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-carousel-item>
</template>



<script>

export default {
  name: 'Slide',
  components: {
    
  },
  props: {
    textAndImageArray: {
      type: Array,
      required: true
    },
    question: {
      type: Object,
      required: true
    },
    sliderQuestionBG: {
      type: String,
      required: true
    },
    sliderFontQuestion: {
      type: String,
      required: true
    },
    sliderFontCards: {
      type: String,
      required: true
    },
    sliderCardTop: {
      type: String,
      required: true
    },
    sliderCardBottom: {
      type: String,
      required: true
    },
    sliderCardBorderDefault: {
      type: String,
      required: true
    },
    sliderCardBorderSelected: {
      type: String,
      required: true
    }
  },
  data: () => ({
    activeCard: ""
  }),
  created() {

  },
  methods: {
    clickCard(cardText) {
      this.activeCard = cardText;
      Event.$emit('cardClicked', {slide: this.question.slide, id: cardText});
    }
  }
};
</script>

<style>
 .row {
  justify-content: center;
 }
 .question {
  max-width: 500px;
  margin: auto;
 }

 .img {
    /* size */
    width: 10rem; height: 10rem;
    /* center offset */
  }
  .grid-text {
    color: #444;
    font-family: "Roboto";
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 0px !important;
  }
  .grid-item {
    /* background */
    background: whitesmoke;
    /* material-ui.com/#/components/paper */
    border-radius: 2px; box-shadow: rgba(0, 0, 0, 0.25) 0px 5px 25px;
    /* transform */
    transition: transform 500ms;
  }
  .grid-item:hover {
    /* transition */
    transition: transform 500ms;
    /* transform */
    transform: scale(1.08);
  }
  .grid-cell--top, .grid-cell--bottom {
    /* flex */
    display: flex;
    /* flex:center */
    justify-content: center; align-items: center;
  }
</style>